module.exports = __webpack_public_path__ + "employees-21b62107/error-a5fd004a6bafb6dd2b3e03b62f126df3.svg";